import { Checkbox, FormControlLabel, InputBase, Popover, Typography } from '@mui/material'
import StyledButton from '../Button/StyledButton'
import { arrowDown, searchIcon } from '../../assets/icons'
import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import SelectField from '../SelectField/SelectField'

const Toolbar = ({
  children,
  handleOpen,
  btnText,
  fees,
  search,
  setSearchItem,
  classView,
  CreditText,
  individualfee,
  holidays,
  transport,
  // width,
  StudentPresence,
  timeTable,
  setPage,
}) => {
  const selected = useSelector((state) => state.global.selectedRow)
  const [localSearch, setLocalSearch] = useState(search)
  const navigate = useNavigate()
  const handleCreditRoute = () => {
    navigate('/credits')
  }
  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)
  // console.log('-----SchoolDInfo',SchoolDInfo);
  const isFeeAlreadyPaid = (fees || individualfee) && SchoolDInfo?.fee_status === 'Paid'

  const isSelectionEmpty = selected.length === 0

  // Main disable conditions
  const isButtonDisabled =
    isFeeAlreadyPaid ||
    (individualfee && isSelectionEmpty) ||
    (fees && isSelectionEmpty) ||
    StudentPresence
  return (
    <div
      style={{
        justifyContent: holidays ? 'flex-end' : '',
      }}
      className="school-toolbar"
    >
      {!classView && !individualfee && !holidays && (
        <InputBase
          placeholder="Search"
          sx={{ width: '200px' }}
          className="search-component"
          value={search}
          onChange={(e) => {
            setSearchItem(e.target.value)
            setPage(1)
          }}
          startAdornment={<img src={searchIcon} alt="" style={{ width: '16px', height: '16px' }} />}
        />
      )}
      <div
        style={{
          justifyContent: individualfee || holidays ? 'flex-end' : '',
          width: individualfee ? '100%' : '',
        }}
        className="filter-container"
      >
        {children}
        {/* <StyledButton
          width={btnText || transport ? 'fit-content' : CreditText ? 'auto' : '128px'}
          onClick={handleCreditRoute}
        >
          <span
            style={{
              verticalAlign: 'middle',
              marginRight: '12px',
            }}
          >
            <img
              src={cash}
              alt=""
              style={{
                width: '16px',
                aspectRatio: '1/1',
                filter: 'brightness(0) invert(1)',
              }}
            />
          </span>
          <span>Collect Fees</span>
        </StyledButton> */}

        {!StudentPresence && (
          <StyledButton
            width={btnText || transport ? 'fit-content' : CreditText ? 'auto' : '128px'}
            onClick={
              (fees || individualfee) && selected.length == 0
                ? () => {}
                : CreditText
                  ? handleCreditRoute
                  : handleOpen
            }
            disabled={isButtonDisabled}
          >
            {btnText ? btnText : CreditText ? CreditText : transport ? '+ Add' : '+ Add'}
          </StyledButton>
        )}
      </div>
    </div>
  )
}

export default Toolbar

export const FilterSection = ({ icon, title, onClick }) => {
  return (
    <div className="filter-box" onClick={onClick}>
      <img src={icon} alt="" />
      <Typography className="filter-text">{title}</Typography>
    </div>
  )
}

export const SelectPopUp = ({ selectedStatus, setSelectedStatus, selectOptions, title }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const handleStatusChange = (status) => {
    if (selectedStatus === status) {
      setSelectedStatus('')
    } else {
      setSelectedStatus(status)
    }
  }
  const open = Boolean(anchorEl)

  return (
    <>
      <div className="filter-box" onClick={handlePopoverOpen}>
        <Typography className="filter-text">{title ? title : 'Select'}</Typography>
        <img src={arrowDown} style={{ width: '20px', height: '20px' }} />
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: '10px', display: 'flex', flexDirection: 'column' }}>
          {selectOptions?.map((option) => (
            <FormControlLabel
              key={option.grade_id}
              control={
                <Checkbox
                  checked={selectedStatus === option.value}
                  onChange={() => handleStatusChange(option.value)}
                />
              }
              label={option.label}
            />
          ))}
        </div>
      </Popover>
    </>
  )
}
